import AppContent from "./AppContent";
import AppProviders from "./AppProviders";
import { encrypt } from "./helpers/generators";

function App() {

  return (
    <AppProviders>
      <AppContent />

    </AppProviders>
  );
}

export default App;
